import React from 'react';
import { situacoesProblemas, situacoesSolucoes, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const SituacoesSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">
            Situações comuns
          </h2>
          <p className="text-neutral-600 text-xl">
            Você se identifica com alguma dessas situações?
          </p>
        </div>
        
        {/* Comparison Cards */}
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Problems Card */}
          <div className="group relative bg-[#2a2523] rounded-2xl p-8 overflow-hidden transition-all duration-500 hover:scale-[1.02]">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" />
            <div className="absolute -right-20 -top-20 w-40 h-40 bg-red-500/10 rounded-full blur-3xl" />
            
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 border-2 border-red-400/50 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-white">
                  Você se identifica com alguma<br />dessas situações?
                </h3>
              </div>
              
              <ul className="space-y-4">
                {situacoesProblemas.map((item, index) => (
                  <li 
                    key={index} 
                    className="flex items-start gap-3 text-neutral-300 group-hover:text-neutral-200 transition-colors"
                  >
                    <div className="mt-1 w-5 h-5 border border-red-400/50 rounded flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* Solutions Card */}
          <div className="group relative bg-emerald-900 rounded-2xl p-8 overflow-hidden transition-all duration-500 hover:scale-[1.02]">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-400" />
            <div className="absolute -right-20 -top-20 w-40 h-40 bg-emerald-400/10 rounded-full blur-3xl" />
            
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 border-2 border-emerald-400/50 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-white">
                  O que fazemos<br />nesses casos
                </h3>
              </div>
              
              <ul className="space-y-4">
                {situacoesSolucoes.map((item, index) => (
                  <li 
                    key={index} 
                    className="flex items-start gap-3 text-emerald-100 group-hover:text-white transition-colors"
                  >
                    <div className="mt-1 w-5 h-5 border border-emerald-400/50 rounded flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-neutral-600 mb-6 text-lg">
            Se você vive alguma dessas situações, fale agora.
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SituacoesSection;
